import { Helmet } from 'react-helmet-async';

interface OrganizationSchemaProps {
  includeWebSite?: boolean;
}

export const OrganizationSchema = ({ includeWebSite = false }: OrganizationSchemaProps) => {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://flatjive.com';
  
  const organizationData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "FlatJive",
    "url": SITE_URL,
    "logo": `${SITE_URL}/placeholder.svg`,
    "description": "FlatJive helps UK share of freehold owners collaborate effectively. Manage service charges, maintenance, documents, and decisions in one platform.",
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "GB"
    },
    "sameAs": [
      "https://twitter.com/flatjive"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "email": "support@flatjive.com",
      "contactType": "Customer Support"
    }
  };

  const webSiteData = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "FlatJive",
    "url": SITE_URL,
    "description": "Less Hassle. More Harmony. Property management platform for UK share of freehold owners.",
    "publisher": {
      "@type": "Organization",
      "name": "FlatJive"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(organizationData)}
      </script>
      {includeWebSite && (
        <script type="application/ld+json">
          {JSON.stringify(webSiteData)}
        </script>
      )}
    </Helmet>
  );
};

interface BreadcrumbItem {
  name: string;
  url: string;
}

interface BreadcrumbSchemaProps {
  items: BreadcrumbItem[];
}

export const BreadcrumbSchema = ({ items }: BreadcrumbSchemaProps) => {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://flatjive.com';
  
  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": `${SITE_URL}${item.url}`
    }))
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbData)}
      </script>
    </Helmet>
  );
};
